import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { closeUserPopup } from "../../redux/actions";
import { PopupContainer } from "./PopupContainer";
import InfiniteScroll from 'react-infinite-scroll-component';


export const UserPopup = () => {
    const dispatch = useDispatch()
    const userPopup = useSelector(state => state.user.userPopup)
    const userPopupName = useSelector(state => state.user.userPopupName)
    const userPopupLoading = useSelector(state => state.user.userPopupLoading)
    const lang = useSelector(state => state.app.currentLang)
    let userArray = userPopup ?? [];
    // let timezone = Math.abs(new Date().getTimezoneOffset()) / 60
    // let timeoffset = '+';
    // if (timezone < 10) {
    //     timeoffset += '0' + timezone.toString() + '00'
    // } else {
    //     timeoffset += timezone.toString() + '00'
    // }
    let heightOfContainer = (userArray.length < 8) ? null : 300;
    let marginOfContainer = (userArray.length < 8) ? "0px" : "0px 0px -26px 0px";
    const fn = (number) => {
        if (parseInt(number) < 10) {
            return '0' + number;
        }
        return number;
    }
    if (userPopupName === null) {
        return null
    }
    return (
        <PopupContainer popup={userPopup} popupName={userPopupName} popupLoading={userPopupLoading} heading={lang.message5} close={() => dispatch(closeUserPopup())}>
            <InfiniteScroll
                dataLength={userArray.length}
                height={heightOfContainer}
                style={{
                    "margin": marginOfContainer,
                    "paddingRight": "10px"
                }}>
                <div className="points">

                    {
                        userArray.map(function (item) {
                            let a = item.createdAt.split(' ')[0].split('-')
                            let b = item.createdAt.split(' ')[1].split(':')
                            let date = new Date(Date.UTC(a[0], parseInt(a[1]) - 1, a[2], b[0], b[1], b[2]))

                            let formateDate = fn(date.getDate()) + '.' + fn((date.getMonth() + 1)) + '.' + date.getFullYear() + '\n';
                            formateDate += ' ' + fn(date.getHours()) + ':' + fn(date.getMinutes()) + ':' + fn(date.getSeconds());
                            return (
                                <div className="points__line" key={item.id}>
                                    <div className="points__date">{formateDate}</div>
                                    <div className="points__icon">
                                        {item.points >= 0 && (
                                            <div className="points__icon_plus"></div>)}
                                        {item.points < 0 && (
                                            <div className="points__icon_minus"></div>)}
                                    </div>
                                    <div className="points__text">{item.reason + " " + (item.profile ? '(' + item.profile + ')' : '')}</div>
                                    <div className="points__score">{item.points}</div>
                                </div>)
                        })
                    }
                </div>
            </InfiniteScroll>
        </PopupContainer>
    )
}